import { Grid } from "@mui/material";
import { FC, useEffect, useState } from "react";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { useAdministratorStore } from "../../hooks/useAdministratorStore";
import { ApiStatus } from "../../types/api/status";
import { ModalConfirm } from "../../components/common/ModalConfirm/ModalConfirm";
import { Administrator } from "../../types/slices/administratorType";
import { AdministratorModal } from "./AdministratorModal";

const columns = [
    { type: 'options', field: 'options', label: 'Acciones', align: 'center' },
    { type: 'text', field: 'rut', label: 'Rut', align: 'center' },
    { type: 'text', field: 'name', label: 'Nombres', align: 'center' },
    { type: 'text', field: 'surname', label: 'Apellidos', align: 'center' },
    { type: 'text', field: 'email', label: 'Correo', align: 'center' },
    { type: 'text', field: 'companies', label: 'Empresa(s)', align: 'center' },
    { type: 'detail', field: 'detail', label: 'Detalle', align: 'center' },
];

export const AdministratorList: FC = () => {

    const { status, administrators, adminSelected, getAdmins, deleteAdmin, setSelectedAdmin } = useAdministratorStore();

    const [action, setAction] = useState<string>('')
    const [showModal, setShowModal] = useState<boolean>(false)
    const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false)
    const [showModalDetail, setShowModalDetail] = useState<boolean>(false)

    useEffect(() => {
        getAdminsApi()
    }, [])

    const getAdminsApi = async () => {
        await getAdmins()
    }

    const onAdd = () => {
        setSelectedAdmin({} as Administrator)
        setAction('create')
        setShowModal(true)
    }

    const onEdit = (rowSelected) => {
        setSelectedAdmin(rowSelected)
        setAction('edit')
        setShowModal(true)
    }

    const onDelete = (rowSelected) => {
        setSelectedAdmin(rowSelected)
        setShowModalConfirm(true)
    }

    const onDeleteConfirm = async (): Promise<void> => {
        const resp = await deleteAdmin(adminSelected?.id)
        if (resp === true) {
            setShowModalConfirm(false)
            getAdminsApi()
        }
    }

    const onDetails = (rowSelected) => {
        setSelectedAdmin(rowSelected)
        setAction('detail')
        setShowModal(true)
    }

    return (
        <Grid item xs={12}>
            <CustomTable
                title={'Administradores'}
                columns={columns}
                loading={status === ApiStatus.FETCHING}
                rows={administrators || []}
                onRowClick={() => { }}
                hasOptions
                onAddFn={onAdd}
                onAddFnName={'Nuevo administrador'}
                onDetails={onDetails}
                onDelete={onDelete}
                onEdit={onEdit}
                onSearch
                dense
            />
            {
                showModalConfirm && (
                    <ModalConfirm
                        open={showModalConfirm}
                        closeModal={() => { setShowModalConfirm(false) }}
                        onConfirm={onDeleteConfirm}
                        status={status === ApiStatus.FETCHING}
                    />
                )
            }
            {
                showModal && <AdministratorModal
                    open={showModal}
                    closeModal={() => { setShowModal(false) }}
                    onList={() => getAdminsApi()}
                    action={action}
                />
            }
        </Grid>
    )
}